import { v4 as uuid } from "uuid"

const getUserIdForAnalytics = () => {
  let newUserId = uuid()
  if (typeof window === "undefined" || typeof localStorage === "undefined") {
    return newUserId
  }

  if (!localStorage.getItem("userId")) {
    // If a user ID is not available, set one for amplitude.
    localStorage.setItem("userId", newUserId)
  }
  return localStorage.getItem("userId") || newUserId
}

export default getUserIdForAnalytics
